import { Component, OnInit } from '@angular/core';
import { FlowMode } from '../../../dto/enum/flow.mode.enum';
import { PublishFlowFacade } from '../../../facades/publish-flow.facade';

@Component({
    selector: 'app-property-third',
    templateUrl: './property-third.component.html',
    styleUrls: ['./property-third.component.scss'],
})
export class PropertyThirdComponent implements OnInit {
    private readonly step = 'third';
    mode: FlowMode = FlowMode.CREATE;
    nextUrl = '';
    previousUrl = '';

    constructor(private readonly flow: PublishFlowFacade) {}

    ngOnInit(): void {
        this.flow.initStep(this.step);
        if (!this.flow.mode) this.flow.setMode(FlowMode.CREATE); // no pisar EDIT/RESUME
        this.mode = this.flow.mode ?? FlowMode.CREATE;
        this.nextUrl = this.flow.nextUrl(this.step);
        this.previousUrl = this.flow.previousUrl(this.step);
    }

    handlePreviousStep(): void {
        this.flow.previous(this.step);
    }

    handleNextStep(): void {
        this.flow.next(this.step);
    }
}
